import { Box, Stack, Typography } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { unit } from '@hcr/ui'

import { COLORS } from '../../../../../../../../libs/ui/src/lib/constants'
import { ButtonSignIn } from '../../../button-sign-in'
import { ButtonSignUp } from '../../../button-sign-up'
import { Metadata } from '../../../metadata'

import { NavigationLinks } from './navigation-links'
import { NavigationMenuDrawer } from './navigation-menu-drawer'

interface NavigationMenuUnauthenticatedProps {
  isVisible: boolean
  setIsVisible: (isVisible: boolean) => void
}

export const NavigationMenuUnauthenticated: FC<NavigationMenuUnauthenticatedProps> = ({ setIsVisible, isVisible }) => {
  const { t } = useTranslation()

  return (
    <NavigationMenuDrawer setIsVisble={setIsVisible} isVisble={isVisible}>
      <Metadata title={t('page-title.unauthenticated')} />
      <Stack paddingY={unit(6)} paddingX={unit(5)} gap={unit(6)}>
        <Stack>
          <Typography component='h1' variant='headlineM' color={COLORS.red['dark']} align={'center'}>
            {t('page-title.login')}
          </Typography>
          <Typography component='h2' variant='bodyM' align={'center'}>
            {t('account.to-view-and-manage-your-account-please-sign-in')}
          </Typography>
        </Stack>
        <Stack gap={unit(5)}>
          <ButtonSignIn variant='contained' color='primary' />
          <ButtonSignUp variant='outlined' color='black' />
        </Stack>
      </Stack>
      <NavigationLinks isLogged={false} isOwner={false} />
      <Box height={unit(12)}></Box>
    </NavigationMenuDrawer>
  )
}
